import React, { forwardRef } from "react";
import { useCotizaciones, aPesos } from "../services/cotizaciones";

// Símbolo real de cada artículo según su tipoDivisa — antes esta orden mostraba
// "$" fijo (formateado además como ARS) aunque el artículo estuviera cargado
// en Dólares/Reales/Euros. Cada artículo de una orden puede tener su propia
// divisa, así que el total se pasa a Pesos para poder sumarlos entre sí.
const SIMBOLOS_DIVISA = { Pesos: "$", "Dólares": "US$", Reales: "R$", Euros: "€" };

const OrdenCompra = React.forwardRef(({
datosProveedor,
datosArticulos,
datosEntrega,
numeroOrden,
modalidadPago,
formData,
abreviaturas, 
fechaEmision
}, ref) => {

const { cotizaciones } = useCotizaciones();

const calcularTotal = () => {
let total = 0;
datosArticulos.forEach(articulo => {
const precioNeto = articulo?.precioUnidad * articulo?.cantidadUnidades;
const descuento = precioNeto * (articulo?.descuentoAplicado / 100);
total += aPesos(precioNeto - descuento, articulo?.tipoDivisa, cotizaciones);
});
return total;
};

const totalFinal = calcularTotal();
const formatFecha = (fecha) => {
  if (!fecha) return "";
  const d = new Date(fecha);
  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const anio = d.getFullYear();
  return `${dia}/${mes}/${anio}`;
};

const numeroComp = numeroOrden ? numeroOrden.split("-")[1] : "0000000X";

const formatPrecio = (valor) => {
  if (isNaN(valor)) return "";
  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
  }).format(valor);
};

// Antes esto formateaba siempre como ARS ("style: currency, currency: ARS"),
// así que un artículo cargado en Dólares/Reales/Euros igual se mostraba con
// formato de pesos. Ahora antepone el símbolo real de ese artículo.
const formatPrecioArticulo = (valor, tipoDivisa) =>
  `${SIMBOLOS_DIVISA[tipoDivisa] || "$"}${formatPrecio(valor)}`;

return (
<div
ref={ref}
style={{
minWidth: "210mm",
minHeight: "297mm",
padding: "17mm 10mm 10mm",
background: "#fff",
fontFamily: "Arial, sans-serif",
color: "#333",
margin: "0 auto",
border: "1px solid #ddd",
borderRadius: "4px",
display:'flex',
flexDirection:'column',
boxSizing: "border-box",
position: 'relative',
}}
>
{/* Primera fila de información */}
<div style={{ display: "flex", justifyContent: "space-between", width: '100%' }}>
<div style={{ width: 'fit-content' }}>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Razón social</b><br />Finca Los Astros S.A.S</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Domicilio Comercial</b><br />
Servidumbre de Tránsito s/n, Fracción C 0, Piso C<br />
5561<br />
El Peral, Provincia de Mendoza<br />
Argentina
</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Teléfono de contacto</b><br />+5491130609103</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Condición frente al IVA</b><br />Responsable Inscripto</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>CUIT</b>: 30-71934761-0</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Ingresos Brutos</b>: 1038057</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Fecha de Inicio de Actividades</b>: 22/12/2025</p>
</div>

<div style={{ width: 'fit-content' }}>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>ORDEN DE COMPRA</b></p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Código</b>: OC2025</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}>
  <b>Comp.Nro.</b>: {numeroOrden ? numeroOrden.split("-")[1] : "0000000X"}
</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}>
  <b>Fecha de emisión</b>: {formatFecha(fechaEmision || new Date())}
</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Domicilio de residencia</b><br />
{datosEntrega?.entregacalle} {datosEntrega?.entregaaltura}<br />
{datosEntrega?.entregaPiso && `Piso ${datosEntrega?.entregaPiso}, `}{datosEntrega?.entregaunidad && `Unidad ${datosEntrega?.entregaunidad}`}<br />
{datosEntrega?.entregaCiudad}, {datosEntrega?.entregaPais}<br />
{datosEntrega?.entregaCodigoPostal}
</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Condición de venta</b><br />{modalidadPago}</p>
</div>
</div>

<div style={{ borderTop: '1px solid #808080', borderBottom: '1px solid #808080', opacity: '0.5', height: '1mm', margin: '10px 0' }}></div>

{/* Segunda fila de información */}
<div style={{ display: "flex", justifyContent: "space-between", width: '100%' }}>
<div style={{ width: 'fit-content' }}>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Razón Social</b><br />{datosProveedor?.razonSocial}</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Domicilio</b><br />
{datosProveedor?.calle} {datosProveedor?.altura}, {datosProveedor?.piso}{datosProveedor?.unidad}<br />
{datosProveedor?.codigoPostal}<br />
{datosProveedor?.ciudad}, {datosProveedor?.pais}<br />
</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Teléfono de contacto</b><br />{datosProveedor?.telefono}</p>
</div>
<div style={{ width: 'fit-content' }}>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Correo electrónico</b><br />{datosProveedor?.correoElectronico}</p>
<p style={{ fontFamily: 'Courier New', margin: '0', fontSize: '11px' }}><b>Nombre del vendedor</b><br />{datosProveedor?.nombreVendedor}</p>
</div>
</div>

<div style={{ borderTop: '1px solid #808080', borderBottom: '1px solid #808080', opacity: '0.5', height: '1mm', margin: '10px 0' }}></div>

{/* Tabla de detalles */}
<table
style={{
width: "100%",
borderCollapse: "collapse",
fontFamily: "'Courier New'",
fontSize: "11px",
}}
>
<thead>
<tr>
<th style={thStyle}>Descripción</th>
<th style={thStyle}>Cantidad</th>
<th style={thStyle}>Unidad</th>
<th style={thStyle}>Precio Uni.</th>
<th style={thStyle}>Descuento</th>
<th style={thStyle}>Total</th>
</tr>
</thead>
<tbody>
{datosArticulos.map((articulo, index) => (
<tr key={index}>
<td style={tdStyle}>{articulo?.nombre}</td>
<td style={tdStyle}>{articulo?.cantidadUnidades}</td>

<td style={tdStyle}>
{articulo?.tipoUnidad ? abreviaturas?.[articulo?.tipoUnidad] : ''}
</td>
<td style={tdStyle}>{formatPrecioArticulo(articulo?.precioUnidad, articulo?.tipoDivisa)}</td>
<td style={tdStyle}>{articulo?.descuentoAplicado}%</td>
<td style={tdStyle}>{formatPrecioArticulo(articulo?.precioUnidad * articulo?.cantidadUnidades * (1 - articulo?.descuentoAplicado / 100), articulo?.tipoDivisa)}
</td></tr>
))}
</tbody>
</table>

<div style={{
margin:'auto auto 0',
display: 'flex',
flexDirection:'column',
width:'100%',
justifyContent: 'space-between',
fontFamily: "'Courier New'",
gap:'10px'
}}>
<div style={{
borderTop: '1px solid #cccccc',
padding: '10px 0',
borderBottom: '1px solid #cccccc',
display:'flex',
flexDirection:'row',
justifyContent:'space-between',
width:'100%'
}}>
<div style={{display:'flex', flexDirection:'row', textAlign: 'right', fontSize: '14px', height:'100%', margin:'0 0 auto auto' , gap:'20px'}}>
<tbody>
<tr style={{display:'flex', flexDirection:'row', gap:'25px', justifyContent:'flex-end'}}>
<td style={{ ...tdStyle, textAlign: 'right', margin: '0 10px', fontWeight: 'bold' }}>Subtotal:</td>
{/* Aplicamos Math.floor() aquí. Convertido a Pesos: la orden puede mezclar artículos en distintas divisas. */}
<td style={{ ...tdStyle, textAlign: 'right', margin: '0', width:'150px' }}>${formatPrecio(Math.floor(totalFinal))}</td>
</tr>
<tr style={{display:'flex', flexDirection:'row', gap:'25px', justifyContent:'flex-end'}}>
<td style={{ ...tdStyle, textAlign:'right', margin:'0 10px', fontWeight:'bold' }}>Importe Otros Tributos:</td>
<td style={{ ...tdStyle, textAlign:'right' ,margin:'0', width:'150px'}}>$0.00</td>
</tr>
<tr style={{display:'flex', flexDirection:'row', gap:'25px', justifyContent:'flex-end'}}>
<td style={{ ...tdStyle, textAlign: 'right', margin: '0 10px', fontWeight: 'bold'}}>Importe total:</td>
{/* Aplicamos Math.floor() aquí. Convertido a Pesos: la orden puede mezclar artículos en distintas divisas. */}
<td style={{ ...tdStyle, textAlign: 'right', margin: '0', width:'150px' }}>${formatPrecio(Math.floor(totalFinal))}</td>
</tr>
</tbody>
</div>
</div>
</div>
</div>
);
});

const thStyle = {
border: "none",
padding: "4px",
background: "none",
textAlign: "center",
textTransform:'uppercase',
minWidth:'50px',
flexWrap: 'nowrap'
};
const tdStyle = {
border: "none",
padding: "4px",
textAlign: "center",
minWidth:'50px',
};

export default OrdenCompra;
